import { NotificationState } from './notification'
import { PainelIconItem } from "@/molds/ListPanelIconsModel";

export default {
	notifications(state: NotificationState): PainelIconItem[] {
		return state.notifications
	},
}
	
